import { render, staticRenderFns } from "./placard_media_instructions.vue?vue&type=template&id=5a0ef4fc&scoped=true"
import script from "./placard_media_instructions.vue?vue&type=script&lang=js"
export * from "./placard_media_instructions.vue?vue&type=script&lang=js"
import style0 from "./placard_media_instructions.vue?vue&type=style&index=0&id=5a0ef4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ef4fc",
  null
  
)

export default component.exports